import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogoClick = (e) => {
        setIsMenuOpen(false);
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    }

    // Prevent scrolling when menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isMenuOpen]);

    return (
        <header className={`header ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="header-bar">
                {/* Left spacer to center logo */}
                <div className="header-spacer"></div>

                <Link to="/" onClick={handleLogoClick} className="logo-container">
                    {/* Placeholder for Logo */}
                    <div className="logo-placeholder">
                        LOGO
                    </div>
                </Link>

                <button className="menu-toggle" onClick={toggleMenu}>
                    {isMenuOpen ? 'CLOSE' : 'MENU'}
                </button>
            </div>

            {/* Full Screen Menu Overlay */}
            <div className={`menu-overlay ${isMenuOpen ? 'active' : ''}`}>
                <nav className="menu-nav">
                    <ul>
                        <li><Link to="/about" onClick={closeMenu}>ABOUT ME</Link></li>
                        <li><Link to="/projects" onClick={closeMenu}>PROJECTS</Link></li>
                        <li><Link to="/contact" onClick={closeMenu}>CONTACT</Link></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
